import React from 'react';
import styles from './index.module.scss';

const SingleCharacteristic = ({ title, value }) => {
  return (
    <div className={styles.value} itemScope itemType='https://schema.org/Thing'>
      <div className={styles.value__texts}>
        <p>{title}</p>
        <p>{value}</p>
      </div>
      <div className={styles.value__hr}></div>
    </div>
  );
};

export default SingleCharacteristic;
